// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addMappingButton {
    align-self: flex-end;
    margin-right: 3px;
}

.mappingRow {
    margin: 5px 3px 3px 3px;
}

.mappingInput {
    width: 190px;
}

.datePicker {
    height: 33px;
}

.placeHolder {
    width: 40px;
}`, "",{"version":3,"sources":["webpack://./src/app/appbuilder/menutabs/datatable/datatable.icons.mapping.dialog.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".addMappingButton {\n    align-self: flex-end;\n    margin-right: 3px;\n}\n\n.mappingRow {\n    margin: 5px 3px 3px 3px;\n}\n\n.mappingInput {\n    width: 190px;\n}\n\n.datePicker {\n    height: 33px;\n}\n\n.placeHolder {\n    width: 40px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
